module.exports = __webpack_public_path__ + "static/media/Karen Kathan Headshot_1629242552626.8cfbb621.jpg";